import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Sparkles, Zap, Archive } from "lucide-react";

interface RoadmapTabsProps {
  className?: string;
}

const RoadmapTabs = ({ className = "" }: RoadmapTabsProps) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const tabs = [
    { 
      id: "big-features", 
      label: "Big Features", 
      path: "/dashboard/roadmap/top-opportunities",
      icon: <Sparkles className="h-4 w-4" />
    },
    { 
      id: "quick-wins", 
      label: "Quick Wins", 
      path: "/dashboard/roadmap/quick-wins",
      icon: <Zap className="h-4 w-4" />
    },
    { 
      id: "archived", 
      label: "Archived", 
      path: "/dashboard/roadmap/archived-opportunities",
      icon: <Archive className="h-4 w-4" />
    }
  ];

  return (
    <div className={`${className} relative z-20`}>
      <div className="bg-white dark:bg-gray-800 rounded-lg p-1.5 border border-gray-200 dark:border-gray-700 flex">
        {tabs.map((tab) => {
          const isActive = currentPath === tab.path;
          return (
            <button
              key={tab.id}
              onClick={() => navigate(tab.path)}
              type="button"
              className={`flex items-center gap-1.5 px-6 py-2.5 rounded-md text-base font-medium transition-colors hover:cursor-pointer ${
                isActive 
                  ? "bg-[#FF4A8E] text-white font-bold shadow-sm" 
                  : "text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-gray-100 hover:bg-gray-50 dark:hover:bg-gray-700"
              }`}
            >
              {tab.icon}
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default RoadmapTabs;
